import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  num: '01',
  title: 'Diagnóstico estratégico',
  desc: 'Analizamos tu operación para entender cómo está construida hoy, dónde están los cuellos de botella y qué está frenando el siguiente nivel.'
}, {
  num: '02',
  title: 'Diseño de estructura',
  desc: 'Definimos procesos, roles, criterios de decisión y la tecnología que tiene sentido para tu caso específico.'
}, {
  num: '03',
  title: 'Implementación con criterio',
  desc: 'Construimos el sistema — con estrategia, liderazgo y tecnología integradas — para que tu negocio funcione con claridad y sin depender de ti.'
}];
export function ProcessSection() {
  return <section className="py-24 px-6 bg-navy-dark" data-id="element-97">
      <div className="max-w-6xl mx-auto" data-id="element-98">
        <FadeIn data-id="element-99">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-20" data-id="element-100">
            Cómo trabajo contigo
          </h2>
        </FadeIn>

        <div className="relative mb-20" data-id="element-101">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-gold/30 z-0" data-id="element-102"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 relative z-10" data-id="element-103">
            {steps.map((step, i) => <FadeIn key={i} delay={i * 0.2} className="flex flex-col items-center text-center" data-id="element-104">
                <div className="w-24 h-24 rounded-full bg-navy border-2 border-gold flex items-center justify-center mb-8 shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-105">
                  <span className="text-3xl font-serif font-bold text-gold" data-id="element-106">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-white mb-4" data-id="element-107">
                  {step.title}
                </h3>
                <p className="text-gray-light text-lg max-w-xs" data-id="element-108">{step.desc}</p>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.6} data-id="element-109">
          <p className="text-center text-sm text-gray-light max-w-2xl mx-auto" data-id="element-110">
            El objetivo no es complicar tu negocio. Es que funcione mejor — y
            que vuelva a estar alineado con lo que realmente importa.
          </p>
        </FadeIn>
      </div>
    </section>;
}